

export class ProjectIncomeDto implements IProjectIncomeDto {
    id!: number;
    projectId!: number;
    projectName!: string | undefined;
    accountId!: number;
    accountName!: string | undefined;
    amount!: number;
    transactionDate!: Date;
    remarks!: string | undefined;

    constructor(data?: IProjectIncomeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.amount = _data["amount"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): ProjectIncomeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectIncomeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["amount"] = this.amount;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        return data; 
    }
}

export interface IProjectIncomeDto {
    id: number;
    projectId: number;
    projectName: string | undefined;
    accountId: number;
    accountName: string | undefined;
    amount: number;
    transactionDate: Date;
    remarks: string | undefined;
}

